export { VehicleDetails } from "./VehicleDetails";
